import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';

@Component({
  standalone: true,
  selector: 'app-link',
  imports: [TranslateModule, RouterLinkActive, RouterLink, InlineSVGModule],
  templateUrl: './app-link.component.html',
  styleUrl: './app-link.component.scss',
})
export class AppLinkComponent {
  label = input.required<string>();
  link = input.required<string>();
  badgeCount = input<number>();
  badgeLabel = input<string>();
  icon = input<string>();
}
